import api, { transformRequest, transformResponse } from "services/api";

export const communicationResultItemsApi = api
  .enhanceEndpoints({
    addTagTypes: ["CommunicationResultItems"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchCommunicationResultItems: build.query({
        query: (payload) => ({
          url: "/api/v1/common/communication-result-items/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response) ?? [],
        providesTags: (results) =>
          results
            ? [
                ...results.map(({ id }) => ({ type: "CommunicationResultItems", id })),
                { type: "CommunicationResultItems", id: "LIST" },
              ]
            : [{ type: "CommunicationResultItems", id: "LIST" }],
      }),
      createCommunicationResultItem: build.mutation({
        query: (payload) => ({
          url: "/api/v1/core/communication-result-items/create/",
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "CommunicationResultItems", id: "LIST" }],
      }),
      updateCommunicationResultItem: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/communication-result-items/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "CommunicationResultItems", id: "LIST" }],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useFetchCommunicationResultItemsQuery,
  useCreateCommunicationResultItemMutation,
  useUpdateCommunicationResultItemMutation,
} = communicationResultItemsApi;
